module.exports = __webpack_public_path__ + "img/3545 Consulting_Logo_white.833d8774.png";